import React, { Component } from 'react';
import { BrowserRouter, HashRouter, Route } from 'react-router-dom'
import { css } from 'aphrodite';

import { Layout, Font, ColorEnvironment } from './Styles';
import Splash from './Splash';
import About from './About';
import Tutorial from './Tutorial';
import ScenarioPicker from './ScenarioPicker';
import ScenarioPlayer from './ScenarioPlayer';
import ScenarioUploader from './ScenarioUploader';

class App extends Component {
  renderContent() {
    return(
      <div className={css(Font.body, Layout.body, ColorEnvironment.normal)}>
        <Route exact path="/" component={Splash}/>
        <Route exact path="/about" component={About}/>
        <Route path="/tutorial/:step" component={Tutorial}/>
        <Route exact path="/cities" component={ScenarioPicker}/>
        <Route path="/cities/:scenarioName" component={ScenarioPlayer}/>
        <Route exact path="/upload" component={ScenarioUploader}/>
      </div>
    );
  }

  render() {
    if (window.location.protocol === "file:") {
      return(
        <HashRouter>
          {this.renderContent()}
        </HashRouter>
      );
    } else {
      return(
        <BrowserRouter>
          {this.renderContent()}
        </BrowserRouter>
      );
    }
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js